(function (root) {
  'use strict';
  function create(maximum) {
    var pending = Promise.resolve();
    var state = { cart: { items: [] }, limits: {} };
    state.limit = function (id) {
      var stock = state.limits[String(id)];
      return stock == null ? maximum : Math.max(0, Math.min(maximum, Number(stock) || 0));
    };
    state.quantity = function (cart, id, exceptKey) {
      return cart.items.reduce(function (sum, item) {
        return sum + (String(item.variant_id) === String(id) && item.key !== exceptKey ? item.quantity : 0);
      }, 0);
    };
    state.remaining = function (cart, id, exceptKey) {
      return Math.max(0, state.limit(id) - state.quantity(cart, id, exceptKey));
    };
    state.updates = function (cart) {
      var used = {}, updates = {};
      cart.items.forEach(function (item) {
        var id = String(item.variant_id), remaining = Math.max(0, state.limit(id) - (used[id] || 0));
        var quantity = Math.min(item.quantity, remaining);
        used[id] = (used[id] || 0) + quantity;
        if (quantity !== item.quantity) updates[item.key] = quantity;
      });
      return updates;
    };
    state.read = function () {
      var url = root.location.pathname + '?section_id=dgch-cart-stock&_stock=' + Date.now();
      return root.fetch(url, { cache: 'no-store' }).then(function (response) {
        if (!response.ok) throw new Error('No se pudo comprobar el stock. Inténtalo de nuevo.');
        return response.text();
      }).then(function (html) {
        var node = new root.DOMParser().parseFromString(html, 'text/html').querySelector('[data-dgch-cart-stock]');
        var data = node && JSON.parse(node.textContent);
        if (!data || !data.cart || !Array.isArray(data.cart.items) || !data.limits) throw new Error('No se pudo comprobar el stock. Inténtalo de nuevo.');
        state.limits = data.limits;
        state.cart = data.cart;
        return state.cart;
      });
    };
    state.run = function (operation) {
      var result = pending.then(operation);
      pending = result.catch(function () {});
      return result;
    };
    return state;
  }
  root.DgchCartStock = { create: create };
})(typeof window !== 'undefined' ? window : globalThis);
